import { FC, useState, useEffect, useCallback, useContext } from 'react';

import { Button, InfoIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { isSandbox } from 'sandbox';

import { ILoadableNotificationProps, IState } from './interfaces';
import s from './LoadableNotification.module.scss';

export const LoadableNotification: FC<ILoadableNotificationProps> = ({
  closable = false,
  direction = 'column',
  className,
}) => {
  const { t } = useContext(LocalizationContext);
  const [state, setState] = useState<IState>({
    data: null,
    shouldRefetch: closable,
  });

  const loadData = useCallback(() => {
    if (isSandbox) {
      setState((prevState) => ({
        ...prevState,
        data: {
          title: 'Демо-режим.',
          message:
            'Все изменения выполняются только в этой вкладке и сбросятся после перезагрузки.',
          link: '',
        },
      }));
      return Promise.resolve();
    }

    return fetch('https://static.smartshell.gg/tpl/message.json', {
      cache: 'no-store',
    })
      .then((response) => response.json())
      .then((response) =>
        setState((prevState) => ({ ...prevState, data: response }))
      )
      .catch(() => setState((prevState) => ({ ...prevState, data: null })));
  }, []);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!state.shouldRefetch) return;

    const interval = setInterval(loadData, 900000);

    return () => clearInterval(interval);
  }, [state.shouldRefetch]);

  if (!state.data) return null;

  const { title, message, link } = isSandbox
    ? {
        title: t('login.sandbox.title'),
        message: t('login.sandbox.message'),
        link: '',
      }
    : state.data;

  return (
    <div className={cn(s.container, s[direction], className)}>
      <div className={s.icon}>
        <InfoIcon />
      </div>
      <div className={s.description}>
        <span className={s.title}>{title}</span>
        <span>
          {isSandbox && direction === 'column' && (
            <>
              {t('login.sandbox.credentials')}
              <br /> <br />
            </>
          )}
          {message}{' '}
          {direction === 'row' && Boolean(link) && (
            <a href={link} target="_blank" className={s.link} rel="noreferrer">
              {t('more')}
            </a>
          )}
        </span>
        {direction === 'column' && Boolean(link) && (
          <a href={link} target="_blank" className={s.link} rel="noreferrer">
            {t('more')}
          </a>
        )}
      </div>
      {closable && (
        <Button
          onlyIcon
          iconName="CloseIcon"
          className={s.close}
          variant="ghost"
          onClick={() =>
            setState(() => ({
              data: null,
              shouldRefetch: false,
            }))
          }
        />
      )}
    </div>
  );
};
